import { usePlanCatalog } from "../lib/queries/index.js";
import { type CapturedEngine, engineMeta } from "./engines.js";

/**
 * The engines this deployment asks, in the server's order: the list the engine
 * filter offers and every "we ask these" surface draws (sign-in, onboarding,
 * a running capture). From `/api/plans`, which the Rust API builds from
 * `CAPTURE_ENGINES`, so an engine switched off on a server is named nowhere it
 * runs. `undefined` while that list loads, or if it could not be read: a page
 * then names no engine rather than guess (AGENTS.md §1).
 */
export function useCapturedEngines(): readonly CapturedEngine[] | undefined {
  const catalog = usePlanCatalog();
  return catalog.data?.engines.map((engine) => engineMeta(engine.id, engine.name));
}
